import React from 'react';
import BankMarketingForm from './BankMarketingForm';
import BankMarketingEdaPage from './BankMarketingEdaPage';
import './BankMarketingPage.css';

const BankMarketingPage: React.FC = () => {
  return (
    <div className="page-container">
      <h1>Bank Marketing Prediction</h1>
      <p>
        This tool predicts whether a client will subscribe to a term deposit based on various
        factors. Fill out the form below with client details, and we'll provide predictions from
        multiple machine learning models.
      </p>
      <BankMarketingForm />

      <div className="bank-marketing-analysis">
        <h2>Bank Marketing Analysis</h2>
        <BankMarketingEdaPage />
      </div>
    </div>
  );
};

export default BankMarketingPage;
